// import JustValidate from 'just-validate';
import { submitForm } from './api';

const frontEndValidation = (formTarget) => {
    const form = window.rcCurrentForm;
    const formId = form.id;
    const formRules = form.rules;

    // const validator = new JustValidate('#' + formId);

    // const formValidator = Object.entries(formRules).map(([fieldName, fieldData]) => {
    //     const { rule } = fieldData;
    //     let outputString = `validator.addField('#${fieldName}', [\n`;

    //     rule.forEach((ruleItem, index) => {
    //         const { rule, value } = ruleItem;
    //         outputString += `  {\n    rule: '${rule}',\n`;
    //         if ('required' === rule) {
    //             outputString += `\n errorMessage: 'This fields is required', \n`;
    //         }
    //         if (value) {
    //             outputString += `    value: '${value}',\n`;
    //         }
    //         outputString += '  },\n';
    //     });

    //     outputString += ']);';
    //     return outputString;
    // });

    // formValidator.join('\n');

    return { isSuccess: true };
}

const backEndValidation = async (formTarget) => {

    let formElement = document.querySelector('form#' + formTarget);

    let formData = new FormData(formElement);

    let formEnties = {};

    for ( let [inputName,inputValue] of formData.entries()){
        formEnties[inputName] = inputValue;
    }

    let form = {
        formId: formElement.id,
        formData: formEnties,
    };

    return await submitForm(form);

}

export { frontEndValidation, backEndValidation };